hrd.config.LocalStorage = hrd.Class.extend({
	init: function(options){
		var defaults = {
			impl: 'hrd.config.LocalStorage',
			prefix: undefined,
			tenant: true,
			node: true,
			user: true
		};
		this._super($.extend({}, defaults, options));
		this.tb = new hrd.Toolbox();
		if(this.settings.prefix == undefined){
			console.log('LocalStorage Facility not properly configured. Prefix is missing');
		} else {
			this.settings.prefix = this.settings.prefix.replace('.', '_');
		}
	},
	/* lazy creation */
	getSessionKey: function(){
		if(this.sessionKey == undefined){
			let c = this.settings;
			let p = hrd.globals.prefs;
			this.sessionKey = `${c.prefix}${c.tenant ? `_${p.tenant.systenant}` : ``}${c.node ? `_${p.node.currentNode}` : ``}${c.user ? `_${p.user.userId}` : ``}`;
		}
		return this.sessionKey
	},
	read: function(){
		var data = Storages.localStorage.get(this.getSessionKey());
		return data;
	},
	write: function(data){
		Storages.localStorage.set(this.getSessionKey(), data);
	},
	clear: function(){
		Storages.localStorage.remove(this.getSessionKey());
	}
});
